import { render, staticRenderFns } from "./ProviderProfile.vue?vue&type=template&id=07935ed5&scoped=true&"
import script from "./ProviderProfile.vue?vue&type=script&lang=js&"
export * from "./ProviderProfile.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfile.vue?vue&type=style&index=0&id=07935ed5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07935ed5",
  null
  
)

export default component.exports